/** QR code 請求資料 */
export interface IReqQRCode {
  /** QR code。 */
  qrCode?: string;

  /** 專利證書號/商標註冊號。 */
  dataNo?: string;

  /** 案件類別。 */
  dataClass?: string;

  /** 證書版本。 */
  uuid?: string;
}

/**
 * 權利是否存續。
 */
export enum QrCodeUuidCheck {
  /** Health Check正確。 */
  U00 = 'u00',
  /** 驗證成功。 */
  U01 = 'u01',
  /** 查無資料。 */
  U02 = 'u02',
  /** 已換補發。 */
  U03 = 'u03',
  /** Health Check異常。 */
  U98 = 'u98',
  /** 其他非預期錯誤。 */
  U99 = 'u99',
}
